import Api from "~/service/Api";

class Immersive3dTourPanoramaZipDownloadRepository {
  fetchOne(tourId, query) {
    return Api.get(`/immersive-3d-tour/panorama-zip-downloads/${tourId}`, query);
  }

  /**
   * Get url for Fetch one
   *
   * @param {number} tourId
   * @returns {string}
   */
  getUrlForFetchOne(tourId) {
    return `/api/immersive-3d-tour/panorama-zip-downloads/${tourId}`;
  }
}

export default Immersive3dTourPanoramaZipDownloadRepository;
